import { render, staticRenderFns } from "./class_pass_manager.vue?vue&type=template&id=2641ca98&"
import script from "./class_pass_manager.vue?vue&type=script&lang=js&"
export * from "./class_pass_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports